import React from 'react';
import { TrendingUp, Users, Camera, Award, UsersRound, Monitor } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';

const iconMap = {
  0: Award,
  1: Users,
  2: Camera,
  3: TrendingUp,
  4: UsersRound,
  5: Monitor
};

const Differentials = ({ t }) => {
  const differentials = t.differentials.items;
  
  return (
    <section className="py-32 bg-gradient-to-b from-black via-gray-950 to-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 luxury-pattern" />
      <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-gold/5 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-gold/5 rounded-full blur-3xl" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20 space-y-4">
          <div className="inline-block">
            <Badge className="bg-gold/20 text-gold border-gold/30 px-4 py-1">
              DIFERENCIAIS
            </Badge>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white heading-luxury">
            {t.differentials.title}
          </h2>
          <div className="section-divider" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {differentials.map((differential, index) => {
            const Icon = iconMap[index];
            return (
              <Card 
                key={differential.id} 
                className="group bg-gradient-to-br from-gray-900 to-black border-gold/20 hover:border-gold transition-all duration-500 luxury-card-hover relative overflow-hidden"
              >
                {/* Animated Background */}
                <div className="absolute inset-0 bg-gradient-to-br from-gold/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                {/* Decorative Lines */}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                <CardContent className="p-8 space-y-6 relative z-10">
                  <div className="relative">
                    <div className="w-20 h-20 bg-gradient-to-br from-gold/20 to-gold/5 rounded-2xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 relative">
                      <div className="absolute inset-0 bg-gold/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all" />
                      <Icon className="h-10 w-10 text-gold relative z-10" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-gold/20 rounded-full blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  </div>
                  
                  <div className="space-y-3">
                    <h3 className="text-2xl font-bold text-white heading-luxury group-hover:text-gold transition-colors">
                      {differential.title}
                    </h3>
                    <div className="h-0.5 w-16 bg-gold group-hover:w-full transition-all duration-700" />
                    <p className="text-gray-400 leading-relaxed">
                      {differential.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Differentials;